import AnimatedEmoji from "@components/AnimatedEmoji"
import { ReactNode } from "react"

interface PageHeaderProps {
  emoji: string
  heading: string
  subheading?: ReactNode
  hasError?: boolean
}

export default function PageHeader({
  emoji,
  heading,
  subheading,
  hasError,
}: PageHeaderProps) {
  return (
    <div className="flex flex-col items-center space-y-6 text-center">
      <AnimatedEmoji emoji={emoji} />

      <div className="space-y-2">
        <h1 className="heading">{heading}</h1>

        {subheading && (
          <p
            className={hasError ? "theme-subheading-error" : "theme-subheading"}
          >
            {subheading}
          </p>
        )}
      </div>
    </div>
  )
}
